// ============================================================================
// LES MOTIFS D'UN ABANDON DE VENTE — la clé que la caisse écrit, le mot qui la lit.
//
// La caisse range dans `abandoned_sale.reason` une CLÉ ; le journal des ventes et le journal d'activité du siège la
// nomment. Chaque écran du siège tenait sa copie de la table : un motif neuf, ajouté d'un côté, s'affichait brut de
// l'autre.
//
// ⚠️ DES CLÉS PERSISTÉES ET REMONTÉES AU SIÈGE : elles ne se renomment jamais — une migration, pas un renommage.
// ⚠️ DU FRANÇAIS, QUI EST LA CLÉ : le back-office le traduit au rendu (`audit-textes-partages` le surveille) ;
//    ce paquet n'embarque aucun moteur de traduction.
// ============================================================================

/** Le mot de la plateforme pour chaque motif d'abandon. */
export const ABANDON_REASON_TEXT = {
  'ticket_vidé': 'Ticket vidé',
  'ticket_vidé_paiement_engagé': 'Ticket vidé, paiement engagé',
  'dernière_ligne_retirée': 'Dernière ligne retirée',
  'dernière_ligne_retirée_paiement_engagé': 'Dernière ligne retirée, paiement engagé',
  'vente_en_attente_supprimée': 'Vente en attente supprimée',
} as const satisfies Readonly<Record<string, string>>;

export type AbandonReason = keyof typeof ABANDON_REASON_TEXT;

/**
 * Le mot d'un motif d'abandon — `null` pour une clé inconnue, que l'appelant montre alors telle quelle : une caisse
 * plus récente peut en écrire une nouvelle, et la taire ferait croire à un abandon sans motif.
 */
export function abandonReasonText(code: string | null | undefined): string | null {
  if (!code) return null;
  return Object.hasOwn(ABANDON_REASON_TEXT, code) ? ABANDON_REASON_TEXT[code as AbandonReason] : null;
}
